// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-link {
  cursor: pointer;
}

.disabled .page-link,
.active .page-link {
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/listing-sort-filtering/Pagination/custom-styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB","sourcesContent":[".page-link {\n  cursor: pointer;\n}\n\n.disabled .page-link,\n.active .page-link {\n  cursor: default;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
